import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

export default function DeleteConfirmationPopup({
  handleClose,
  component,
  open,
  maxWidth,
  title,
  text,
  subtext, buttonTitle,handleSubmit 
}) {
  return (
    <>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px", // 👈 custom border radius here
          },
        }}
      >
        <DialogTitle
          textAlign="start"
          color="#572575"
          mb={2}
          fontFamily="Inter"
          fontSize="20px"
        >
          {title ? title : ""}{" "}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            
          >
            <Grid item xs={12} textAlign="center">
              <IconButton
                style={{
                  width: 81,
                  height: 81,

                  backgroundColor: "#8A40B51A", // semi-transparent white
                  borderRadius: "50%",

                  backdropFilter: "blur(4px)", // optional: glass effect

                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.4)",
                  },
                }}
              >
                {/* <DeleteIcon
                  style={{ color: "#8A40B5", width: "40px", height: "40px" }}
                /> */}

                <img src="/newdashboard/Classrom/Attendance/7cfe3fbcb4fa825f84b502554ae5c47250f6c94f.gif"/>
              </IconButton>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Typography
                fontSize="22px"
                color="#8A40B5"
                sx={{
                  fontWeight: 700,
                  fontFamily: "Inter",
                  lineHeight: "100%",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                {text}
              </Typography>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Typography
                fontSize="14px"
                color="#444444"
                px={5}
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  lineHeight: "1.4",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                {subtext}
              </Typography>
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Box
                sx={{
                  background: "#BA15150F",
                  padding: "10px",
                  borderRadius: "8px",
                }}
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={1}
              >
                <InfoIcon style={{ color: "#BA1515" }} />
                <Typography
                  fontSize="12px"
                  color="#BA1515"
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Inter",
                    lineHeight: "100%",
                    fontStyle: "normal",
                    letterSpacing: "0%",
                  }}
                >
                  This action cannot be undone.
                </Typography>
              </Box>
            </Grid>

            {/* Cancel Button */}
            <Grid
              item
              container
              gap={2}
              justifyContent="center"
              alignItems="center"
              mt={2}
              mb={2}
            >
              <Button
                variant="outlined"
                startIcon={<CloseIcon />}
                onClick={(e) => handleClose(e)}
                sx={{
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#572575",
                  borderColor: "#E0D5EB",
                  backgroundColor: "#F7F3FA",
                  "&:hover": {
                    backgroundColor: "#EFE6F5",
                    borderColor: "#CBB6DB",
                  },
                }}
              >
                Cancel
              </Button>

              {/* Remove All Button */}

              <Button
                variant="contained"
                startIcon={<DeleteIcon />}
                onClick={handleSubmit}
                sx={{
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#572575",
                  "&:hover": {
                    backgroundColor: "#4A1E66",
                  },
                }}
              >
               {buttonTitle}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
